import API from 'services/api';

export const getProfilePackages = () => API.get('/api/profile/packages');
